import { Trans, useTranslation } from 'react-i18next';

import coinsGift from '../../../../assets/auth/coins_gift.webp';
import crownIcon from '../../../../assets/crown_straight.svg';
import Button from '../../../../components/buttons/Button';
import { DialogContent } from '../../../../components/Dialog/DialogUiRedesign/DialogContent';
import { SocialCoin } from '../../../../components/SocialCoin/SocialCoin';
import { SweepCoin } from '../../../../components/SweepCoin/SweepCoin';

import styles from './WelcomeBonusStaticContent.module.scss';

interface Props {
  gcAmount: string;
  isScVisible: boolean;
  onClaim: () => void;
  scAmount: string;
  showGcAmount: boolean;
}

export function WelcomeBonusStaticContent({ gcAmount, isScVisible, onClaim, scAmount, showGcAmount }: Props) {
  const { t } = useTranslation();

  return (
    <DialogContent className={styles.container}>
      <div className={styles.topTextContainer} data-testid="welcome-bonus-top-text">
        <Trans
          components={{
            intro: <span className={styles.topText} />,
            brand: <span className={styles.topTextTitle} />,
            claim: <span className={styles.topTextClaim} />,
          }}
          i18nKey="welcome.welcomeToCrownCoinsClaim"
        />
      </div>
      <div className={styles.coins}>
        {showGcAmount && (
          <>
            <SocialCoin alt="Gold Coins" className={styles.coin} />
            <span className={styles.amount} data-testid="welcome-bonus-cc-amount">
              {gcAmount}
            </span>
          </>
        )}
        {isScVisible && showGcAmount && <span className={styles.plus}>+</span>}
        {isScVisible && (
          <>
            <div className={styles.sweepCoinWrapper}>
              <img alt="" className={styles.crown} src={crownIcon} />
              <SweepCoin alt="Sweep Coins" className={styles.coin} />
            </div>
            <span className={styles.amount} data-testid="welcome-bonus-sc-amount">
              {scAmount}
            </span>
          </>
        )}
      </div>
      <img alt="" className={styles.bonusImage} src={coinsGift} />
      <Button btnType="main" data-testid="claim-welcome-bonus-button" onClick={onClaim}>
        {t('common.buttons.claimNow')}
      </Button>
    </DialogContent>
  );
}
